<template>
  <Modal
    :open="displayModal"
    :title="'Edit ' + data.name"
    size="large"
    modalIcon="fa-solid fa-buildings"
    modalIconColor="bg-blue-100 text-blue-700"
    :showEscapeButton="true"
    :showAcceptButton="true"
    acceptButtonText="Save"
    @close="displayModal = false"
    @onSuccess="updateNetwork"
    ref="modal"
  >
    <div class="grid grid-cols-1 gap-4">
      <div>
        <label
          for="network_name"
          class="block text-sm font-medium text-gray-700"
          >Network Name</label
        >
        <input
          type="text"
          name="network_name"
          id="network_name"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.name"
        />
      </div>
      <div>
        <label for="market_type" class="block text-sm font-medium text-gray-700"
          >Market Type</label
        >
        <select
          id="market_type"
          name="market_type"
          class="mt-1 block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
          v-model="data.marketType"
        >
          <option value="national">National</option>
          <option value="local">Local</option>
          <option value="internal">Internal</option>
        </select>
      </div>
      <div v-if="data.marketType == 'local'">
        <label
          for="market_location"
          class="block text-sm font-medium text-gray-700"
          >Market Location</label
        >
        <span class="py-2" v-if="data.location !== null"
          >Selected: {{ data.location }}</span
        >
        <SearchListBox
          :dataArr="locationCollection"
          placeholder="Type to search for a location..."
          resId="market_location"
          textKey="text"
          @onSearch="onSearch"
          @onSelect="onSelectItem"
        />
      </div>

      <div class="flex flex-col space-y-2">
        <h4 class="block text-sm font-medium text-gray-700">
          Rights and Clearances Contacts
        </h4>

        <div
          class="flex flex-row justify-between bg-gray-200 px-4 py-2 rounded-md text-md"
          v-for="email in data.rcEmails"
          v-bind:key="email"
        >
          {{ email }}
          <span
            class="cursor-pointer hover:text-red-600"
            v-on:click="removeEmail(email)"
            ><i class="fa-solid fa-trash-can"></i
          ></span>
        </div>
        <div
          class="flex flex-row justify-between bg-gray-200 pr-4 py-2 rounded-md"
        >
          <input
            type="email"
            name="email"
            id="email"
            class="block flex-1 shadow-none sm:text-sm rounded-md bg-transparent border-0 focus:ring-0 -my-2 text-md"
            v-model="rcEmail"
            placeholder="email@address.com"
          />
          <button
            class="focus:outline-none hover:text-blue-600"
            v-on:click="addRCEmail"
          >
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-col space-y-2">
        <h5 class="block text-sm font-medium text-gray-700">
          Additional Settings
        </h5>
        <div class="flex flex-col space-y-2">
          <div class="flex flex-row space-x-4 items-center pl-4">
            <input
              name="displayPricingDefault"
              id="displayPricingDefault"
              type="checkbox"
              class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
              v-model="data.displayPricingDefault"
            />
            <label for="displayPricingDefault" class="sm:text-sm">
              Include this network in the video approval window.
            </label>
          </div>
          <div class="flex flex-row space-x-4 items-center pl-4">
            <input
              name="excludeFromPendingPurchases"
              id="excludeFromPendingPurchases"
              type="checkbox"
              class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
              v-model="data.excludeFromPendingPurchases"
            />
            <label for="excludeFromPendingPurchases" class="sm:text-sm">
              Exclude network from "ALL" in pending sales
            </label>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";

import { mapActions } from "vuex";
import axios from "axios";
import Modal from "@/components/Modal";
import SearchListBox from "@/components/SearchListBox";

export default {
  data() {
    return {
      displayModal: false,
      rcEmail: null,
      data: {
        name: null,
        marketType: "national",
        rcEmails: [],
        location: null,
        displayPricingDefault: false
      },
      locationCollection: [],
      isProgressing: false
    };
  },

  components: {
    Modal,
    SearchListBox
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-edit-network-open-modal", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-edit-network-open-modal", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    close() {
      this.displayModal = false;
    },

    open(data) {
      this.data = data;
      this.data.location = data.locationText;
      if (this.data.rcEmails == null) {
        this.data.rcEmails = [];
      }
      this.displayModal = true;
    },

    async updateNetwork() {
      try {
        let res = await this.$http.post(
          Config.apiPath + "/api/v2/admin/networks/" + this.data.id + "/edit",
          this.data
        );
        this.$eventBus.$emit("admin-network-refresh-data");
        this.displayModal = false;

        this.addToastMessage({
          title: "Success",
          text: "The network was updated.",
          type: "success"
        });
      } catch (e) {}
    },

    async onSearch(searchText) {
      const arcgis = axios.create({
        baseURL: "https://geocode.arcgis.com"
      });
      delete arcgis.defaults.headers.common["Authorization"];
      const res = await arcgis.get(
        "/arcgis/rest/services/World/GeocodeServer/suggest?f=json&countryCode=USA%2CPRI%2CVIR%2CGUM%2CASM%2CCAN&category=Postal%2CPopulated+Place&maxSuggestions=10&text=" +
          searchText
      );
      this.locationCollection = res.data.suggestions;
    },

    async onSelectItem(item) {
      this.locationCollection = [];
      this.data.location = item.text;
    },
    removeEmail(email) {
      var index = this.data.rcEmails.indexOf(email);
      if (index !== -1) {
        this.data.rcEmails.splice(index, 1);
      }
    },
    addRCEmail() {
      var index = this.data.rcEmails.indexOf(this.rcEmail);

      var re = /\S+@\S+\.\S+/;
      if (!re.test(this.rcEmail)) {
        alert("Not a valid email address.");
        return;
      }

      if (index == -1) {
        this.data.rcEmails.push(this.rcEmail);
      } else {
        alert("This email already exists.");
        return;
      }
      this.rcEmail = null;
    }
  }
};
</script>
